import { render } from "./403.vue?vue&type=template&id=71843bed"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1444689866/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__